import { CollectiblesList } from '@/components/collectibles/CollectiblesList';
import { PageContainer } from '@startupquickstart/frontend';

const breadcrumbs = [
  { label: 'Home', href: '/' },
  { label: 'Collectible Library', current: true },
];

export function CollectiblesPage() {
  return (
    <PageContainer>
      <CollectiblesList breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
